import React from 'react';
import { Box, Typography, Stack, Paper } from '@mui/material';
import HebrewDatePicker from '../components/HebrewDatePicker';

const navy = '#1e3a5f';

/**
 * TimelineValidityStep
 * הגדרת טווח תאריכים שבו זמני התפילות יוזרקו לציר הזמן היומי.
 * ברירת מחדל: ללא הגבלה (ריק).
 *
 * formData.timelineValidFrom: string (YYYY-MM-DD) | ''
 * formData.timelineValidTo:   string (YYYY-MM-DD) | ''
 */
const TimelineValidityStep = ({ formData, onChange }) => {
  return (
    <Box dir="rtl">
      <Typography sx={{ fontWeight: 700, color: navy, fontSize: '1rem', mb: 0.5 }}>
        תוקף הצגה בציר הזמן
      </Typography>
      <Typography sx={{ fontSize: '0.8rem', color: '#6b7280', mb: 2.5, lineHeight: 1.65 }}>
        זמני התפילות של רכיב זה מוזרקים אוטומטית לציר הזמן היומי (ZmanimWidget).
        כדי להציג זמני תפילות לתקופה מוגבלת — למשל זמני תפילות מיוחדים לחול המועד שיחול בעוד מספר ימים —
        ניתן לקבוע טווח תאריכים שבו הזמנים יוצגו בציר. מחוץ לטווח הרכיב ימשיך לפעול
        אך הזמנים <strong>לא יופיעו בציר הזמן</strong>.
        <br/>
        ברירת מחדל: ללא הגבלה — הזמנים מוצגים בציר תמיד.
      </Typography>

      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Box sx={{ flex: 1 }}>
          <HebrewDatePicker
            label="מתאריך"
            value={formData?.timelineValidFrom || ''}
            onChange={(date) => onChange({ timelineValidFrom: date })}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <HebrewDatePicker
            label="עד תאריך"
            value={formData?.timelineValidTo || ''}
            onChange={(date) => onChange({ timelineValidTo: date })}
          />
        </Box>
      </Stack>

      <Paper elevation={0} sx={{ bgcolor: '#fffbeb', border: '1px solid #fde68a', borderRadius: 2, px: 2, py: 1.25, mt: 2.5 }}>
        <Typography sx={{ fontSize: '0.75rem', color: '#92400e', lineHeight: 1.6 }}>
          <strong>לדוגמה:</strong> אם יש לך זמני תפילות מיוחדים לחול המועד סוכות שיחול בין ט"ו–כ"א בתשרי,
          בחר את התאריכים המתאימים מהלוח כדי שהזמנים יוצגו בציר רק בתקופה זו.
          הרכיב עצמו ימשיך להופיע בלוח — רק ההזרקה לציר הזמן מושפעת.
        </Typography>
      </Paper>
    </Box>
  );
};

export default TimelineValidityStep;
